/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business ダッシュボードルート。アクセス時にKPIページ（/kpi）へリダイレクト
 * @graph-connects none
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

/** @graph-connects none */
export const Route = createFileRoute('/dashboard')({
  beforeLoad: (): never => {
    throw redirect({ to: '/kpi' }) as unknown as Error;
  },
  component: () => null,
});
